var map = {
	"./ethers/selectors.js": 1259,
	"./ipfs/selectors.js": 1260,
	"./uport/selectors.js": 1261
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2165;


//////////////////
// WEBPACK FOOTER
// ./src/assimilation/store \.\/.+\/selectors\.js$
// module id = 2165
// module chunks = 1